/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { GetFrontCategorieParams } from '../schemas/getFrontCategorieParams.ts';
import type { WsRispostaPaginataListCategoriaDTO } from '../schemas/wsRispostaPaginataListCategoriaDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco delle categorie
 * @summary Elenco categorie
 */
export const getFrontCategorie = (
  params?: GetFrontCategorieParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListCategoriaDTO>(
    { url: `/framework-cmp-domande/categorie`, method: 'get', params, signal },
    options,
  );
};

export const getGetFrontCategorieQueryKey = (
  params?: GetFrontCategorieParams,
) => [`/framework-cmp-domande/categorie`, ...(params ? [params] : [])] as const;

export const getGetFrontCategorieQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontCategorie>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFrontCategorieParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontCategorie>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontCategorie>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontCategorieQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontCategorie>>
  > = ({ signal }) => getFrontCategorie(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontCategorieQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontCategorie>>
>;
export type GetFrontCategorieQueryError = ErrorType<unknown>;

/**
 * @summary Elenco categorie
 */
export const useGetFrontCategorie = <
  TData = Awaited<ReturnType<typeof getFrontCategorie>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFrontCategorieParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontCategorie>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontCategorieQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
